import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import { editScenarioGroupData } from '../actions/scenarioGroupAction'
//import { updateScenarioGroupDetails } from './UserFunctions'
import { editDb } from './UserFunctions'
//import Popup from './PopUp.js'
import PropTypes from 'prop-types';

class EditScenarioGroupModal extends Component {
    constructor(){
        super()
        this.state = {
            scenario_id: "",
            scenario_group_name: "",
            scenario_uuid: "",
            scenario_name: "",
        }
        this.onScenarioNameChange = this.onScenarioNameChange.bind(this);
        this.onScenarioUUIDChange = this.onScenarioUUIDChange.bind(this);
    }


    componentDidMount() {
        this.setState( (prevState) => {
            if(this.props.content){
                return{
                    scenario_id: this.props.content.scenario_id,
                    scenario_group_name: this.props.content.scenario_group_name,
                    scenario_uuid: this.props.content.scenario_uuid,
                    scenario_name: this.props.content.scenario_name
                }
            } else {
                return {
                    scenario_id: "",
                    scenario_group_name: "",
                    scenario_uuid: "",
                    scenario_name: ""
                }
            }
        })
    }

    onScenarioUUIDChange = (e) => {
        const scenario_uuid = e.target.value;
        this.setState(() => ({scenario_uuid}));
    }

    onScenarioNameChange = (e) => {
        const scenario_name = e.target.value;
        this.setState(() => ({scenario_name}))
    }

    onSubmit = (e) => {
        e.preventDefault();
        const submitValue = {
            scenario_id: this.state.scenario_id,
            scenario_group_name: this.state.scenario_group_name,
            scenario_uuid: this.state.scenario_uuid,
            scenario_name: this.state.scenario_name,
            scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
            sequence: this.props.content.sequence,
            scenario_group_id: this.props.content.scenario_group_id
        }
        //console.log(this.state);
//        updateScenarioGroupDetails(submitValue).then( (response)=> {
//            console.log(response);
//        })

        const edit_api_url = (window.location.origin).concat('/edit')
        const data_for_api = {
            scenario_uuid : submitValue['scenario_uuid'],
            scenario_description : submitValue['scenario_name']
        }
        editDb(edit_api_url, data_for_api).then(res => {
            console.log("Status of updation : ", res['data']['status'])
            if(res['data']['status'] === "Updated Successfully"){
                this.props.dispatch(editScenarioGroupData(submitValue));
                this.props.handleEditModalClose();
            }

        })

        //this.props.dispatch(editScenarioGroupData(submitValue));
        //this.props.handleEditModalClose();
    };

    render () {
        return(
                <div>
                    <Modal isOpen={!!this.props.editSelectedRow}>
                        <ModalHeader
                            toggle={this.props.handleEditModalClose}
                            style={{ color:"#524fa1" }}
                        >
                            Edit Scenario Group
                        </ModalHeader>
                        <ModalBody>
                            <div className="card">
                              <div className="card-body">
                                <form onSubmit={this.onSubmit}>
                                  <div className="form-group">
                                    <label htmlFor="scenarioId" style={{ color:"#524fa1" }} >Scenario Id</label>
                                    <input
                                        type="text"
                                        disabled={true}
                                        className="form-control"
                                        id="scenarioId"
                                        placeholder="Scenario Id"
                                        value={this.state.scenario_id}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="scenarioGroupName" style={{ color:"#524fa1" }} >Scenario Group Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="scenarioGroupName"
                                        disabled={true}
                                        placeholder="Scenario Group Name"
                                        value={this.state.scenario_group_name}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="scenarioUUID" style={{ color:"#524fa1" }} >Scenario UUID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="scenarioUUID"
                                        disabled={true}
                                        placeholder="Scenario UUID"
                                        value={this.state.scenario_uuid}
                                        onChange={this.onScenarioUUIDChange}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="scenarioName" style={{ color:"#524fa1" }} >Scenario Description</label>
                                    <textarea
                                        className="form-control"
                                        id="scenarioName"
                                        placeholder='Scenario Name'
                                        value={this.state.scenario_name}
                                        onChange={this.onScenarioNameChange}
                                     >
                                     </textarea>
                                  </div>
                                  <button type="submit" className="btn">Submit</button>
                                </form>
                              </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                          <Button color="secondary" onClick={this.props.handleEditModalClose}>Cancel</Button>
                        </ModalFooter>
                      </Modal>

                </div>
            )
    }
}
EditScenarioGroupModal.propTypes={
content:PropTypes.string,
dispatch:PropTypes.string,
handleEditModalClose:PropTypes.string,
editSelectedRow:PropTypes.string,
//navigateHome:PropTypes.string,
}
EditScenarioGroupModal.defaultProps= {
content:[],
dispatch:[],
handleEditModalClose:[],
editSelectedRow:[],
//navigateHome:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };

export default connect()(EditScenarioGroupModal)
